module.exports = __webpack_public_path__ + "img/feda418.jpg";